import { render } from "./ice-breakers.vue?vue&type=template&id=7ca1a00e&scoped=true"
import script from "./ice-breakers.vue?vue&type=script&lang=js"
export * from "./ice-breakers.vue?vue&type=script&lang=js"

import "./ice-breakers.vue?vue&type=style&index=0&id=7ca1a00e&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca1a00e"]])

export default __exports__